import "../css/index.css"
import "preline"
import Glide from "@glidejs/glide"

// GLIDE

if (document.querySelector(".glide-1")) {
    const config = {
        type: "carousel",
        perView: 4,
        focusAt: "1",
        gap: 24,
        autoplay: 3000,
        hoverpause: true,
        breakpoints: {
            1200: {
                perView: 3,
            },
            992: {
                perView: 3,
            },
            768: {
                perView: 2,
            },
            576: {
                perView: 1.5,
                focusAt: "center",
            },
        },
    }
    new Glide(".glide-1", config).mount()
}
if (document.querySelector(".glide-2")) {
    const config = {
        type: "carousel",
        perView: 3,
        focusAt: "1",
        gap: 24,
        autoplay: 3000,
        hoverpause: true,
        breakpoints: {
            1200: {
                perView: 3,
            },
            992: {
                perView: 3,
            },
            768: {
                perView: 2,
            },
            576: {
                perView: 1.5,
                focusAt: "center",
            },
        },
    }
    new Glide(".glide-2", config).mount()
}

// Gallery
const gallery = document.getElementById("lightgallery")
const plans = document.getElementById("plansGallery")
if (gallery) {
    lightGallery(gallery, {
        zoomFromOrigin: false,
    })
}
if (plans) {
    lightGallery(plans, {
        zoomFromOrigin: false,
    })
}

// Video
const playVideo = document.getElementById("videoPlay")

if (playVideo) {
    playVideo.addEventListener("click", () => {
        const videoPlayer = document.getElementById("videoPlayer")
        const videoClose = document.getElementById("videoClose")
        videoPlayer.classList.remove("hidden")
        videoPlayer.classList.add("flex")
        videoClose.addEventListener("click", () => {
            videoPlayer.classList.remove("flex")
            videoPlayer.classList.add("hidden")
            const video = videoPlayer.querySelector("iframe")
            video.src = "https://www.youtube.com/embed/Zo23fYOv2O0"
        })
    })
}

// Navigation
// const navbar = document.getElementById("navbar")
// if (navbar) {
//     window.addEventListener("scroll", () => {
//         const logo = navbar.querySelector("#siteLogo")
//         if (window.scrollY >= 50) {
//             logo.classList.remove("w-16")
//             logo.classList.add("w-11")
//         } else {
//             logo.classList.remove("w-11")
//             logo.classList.add("w-16")
//         }
//     })
// }
